import { Sort, useGetFolderContentQuery } from "lib/types/graphql";
import { SessionWithUser } from "lib/users/types";
import { useActiveContext } from "shared/ContextSwitcher/store";

export function useRecentlyUpdated(session: SessionWithUser) {
  const selectedOwner = useActiveContext();
  const teamId = selectedOwner?.type === "team" ? selectedOwner.id : undefined;

  const recentlyUpdatedParams = {
    input: {
      filter_by: {
        archived: false,
        folder_id: undefined,
        private: undefined,
        name: undefined,
      },
      limit: 3,
      offset: 0,
      order_by: [{ key: "updated_at", sort: Sort.Desc }],
      team_id: teamId,
    },
  };

  const recentlyUpdated = useGetFolderContentQuery({
    context: { session },
    variables: recentlyUpdatedParams,
    fetchPolicy: "network-only",
  });

  return recentlyUpdated;
}
